import { render } from "./docentes.vue?vue&type=template&id=dceef7c8&scoped=true"
import script from "./docentes.vue?vue&type=script&lang=js"
export * from "./docentes.vue?vue&type=script&lang=js"

import "./docentes.vue?vue&type=style&index=0&id=dceef7c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dceef7c8"]])

export default __exports__